import { render } from "./IconBad.vue?vue&type=template&id=65c942ae"
import script from "./IconBad.vue?vue&type=script&lang=js"
export * from "./IconBad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__